import React from "react";
import PropTypes from "prop-types";
import selectn from "selectn";

import styles from "./TextOverHeadline.css";

export default function TextOverHeadline({ rubric, isFeatured }) {
  const textOverStory = selectn("name", rubric) || (isFeatured && "Featured");
  const textOverColor = selectn("hex_color", rubric);

  return (
    textOverStory ?
      <div className={styles.root} style={textOverColor && { color: `#${textOverColor}` }}>{textOverStory}</div>
      : null
  );
}

TextOverHeadline.propTypes = {
  isFeatured: PropTypes.bool,
  rubric: PropTypes.shape({
    name: PropTypes.string.isRequired,
    hex_color: PropTypes.string.isRequired,
  }),
};
